import { USER_PREFERENCE_REGISTRY } from '@/business-logic/user-preferences/userPreferenceRegistry'
import { buildTeamAdvancedSettingRegistry } from '@/business-logic/team-advanced-settings/teamAdvancedSettingDiscovery'

export const TEAM_ADVANCED_SETTING_REGISTRY = buildTeamAdvancedSettingRegistry(
  require.context('./settings', false, /\.js$/),
  USER_PREFERENCE_REGISTRY,
)
